import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../assets/GiftLoopWordmark.svg";
import Button from "../Button/Button";

export default function NavBar() {
    const { user, logoutUser } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const handleLogout = async () => {
        try {
            await logoutUser();
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        // Close menu whenever user changes (login, logout, or switch)
        setMenuOpen(false);
    }, [user]);


    const fallbackAvatarLetter = user
        ? user.displayName?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase()
        : "";

    return (
        <nav className="sticky top-0 z-50 flex items-center justify-between px-6 py-3 bg-white shadow-md">
            {/* Logo */}
            <div className="flex items-center">
                <Link to="/">
                    <img src={Logo} alt="GiftLoop Logo" className="h-8 w-auto" />
                </Link>
            </div>

            {/* Navigation Links and Avatar */}
            <div className="flex items-center space-x-6">
                {user ? (
                    <>
                        <Link
                            to="/"
                            className="text-text hover:text-primary font-bold text-sm uppercase transition-colors duration-200 tracking-wide"
                        >
                            My Lists
                        </Link>

                        <div className="relative" ref={menuRef}>
                            <button
                                onClick={() => setMenuOpen(!menuOpen)}
                                className="w-10 h-10 rounded-full overflow-hidden border-2 border-surface focus:outline-none flex items-center justify-center bg-surface font-bold"
                            >
                                {fallbackAvatarLetter}
                            </button>

                            {menuOpen && (
                                <div className="absolute right-0 mt-2 w-48 bg-white border border-surface rounded-md shadow-lg py-1 z-50">
                                    <Link
                                        to="/account"
                                        className="block px-4 py-2 hover:bg-surface"
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        Account Settings
                                    </Link>
                                    <button
                                        onClick={handleLogout}
                                        className="w-full text-left px-4 py-2  hover:bg-surface"
                                    >
                                        Logout
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <Link
                            to="/login"
                            className="text-text hover:text-primary font-bold text-sm uppercase transition-colors duration-200 tracking-wide"
                        >
                            Login
                        </Link>
                        <Link
                            to="/signup"
                        >
                            <Button type="text" variant="primary" className="w-full">Sign Up</Button>
                        </Link>
                    </>
                )}
            </div>
        </nav>
    );
}
